import { useCallback } from 'react';
import {
  IResponseErrorInterceptorNotificationProps,
  responseErrorInterceptorNotification,
} from '@@/common/utils/response-error-interceptor-notification.util';

export function useResponseErrorInterceptorHandler<
  Args extends Array<any>,
  Return = void,
>(props: IUseResponseErrorInterceptorHandler<Args, Return>) {
  const { handler, ...rest } = props;

  return useCallback(
    async (...args: Args) => {
      return responseErrorInterceptorNotification<Return>({
        handler: () => props.handler(...args),
        ...rest,
      });
    },
    [props.handler, ...(props.dependencies ?? [])],
  );
}

export interface IUseResponseErrorInterceptorHandler<
  Args extends Array<any>,
  Return = void,
> extends Omit<IResponseErrorInterceptorNotificationProps<Return>, 'handler'> {
  handler: (
    ...args: Args
  ) => ReturnType<IResponseErrorInterceptorNotificationProps<Return>['handler']>;
  dependencies?: any[];
}
